import WizardLayout from './wizardLayout.js';

export default WizardLayout;
